module.exports = __webpack_public_path__ + "static/media/celular-app.e5f7584a.png";